import React from "react"
import "./LandingPage.css"

export default function Terms() {
  return (
    <div className="lp-shell">
      <div className="lp-legal">
        <h1>Terms of Service</h1>
        <p>Last updated: April 30, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By installing and using AgentColab ("the Software"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Software.</p>

        <h2>2. License</h2>
        <p>AgentColab is provided under the license included in the distribution. You may install and run the Software on your own infrastructure for personal or commercial use subject to the terms of that license.</p>

        <h2>3. Self-Hosted Software</h2>
        <p>AgentColab is self-hosted software. You are responsible for:</p>
        <ul>
          <li>Maintaining the server infrastructure where the Software runs</li>
          <li>Securing your installation, including API keys, credentials, and network access</li>
          <li>Backing up your data regularly</li>
          <li>Applying updates and security patches</li>
        </ul>

        <h2>4. Data and Privacy</h2>
        <p>AgentColab does not transmit your data to any external service after installation. All data processing occurs on your infrastructure. We do not have access to your conversations, agent configurations, or stored credentials.</p>

        <h2>5. Disclaimer of Warranties</h2>
        <p>THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT, OR OTHERWISE, ARISING FROM, OUT OF, OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>

        <h2>6. Limitation of Liability</h2>
        <p>In no event shall the creators of AgentColab be liable for any direct, indirect, incidental, special, consequential, or exemplary damages resulting from the use or inability to use the Software.</p>

        <h2>7. Modifications</h2>
        <p>We may update these Terms from time to time. Continued use of the Software after changes constitutes acceptance of the updated Terms.</p>

        <h2>8. Contact</h2>
        <p>For questions about these Terms, contact support@agentcolab.io.</p>
      </div>
    </div>
  )
}
